<template>
  <div>
    <compensatory-request-search
      :compensatory-request-search-init-filters="
        compensatoryRequestSearchInitFilters
      "
      :compensatory-request-search="compensatoryRequestSearch"
      :get-compensatory-request-replacement="
        getCompensatoryRequestInterventions
      "
      :get-municipalities="getMunicipalities"
      :get-schools="getSchools"
      :get-regions="getRegions"
      :get-districts="getDistricts"
      :get-providers-by-academicyear-id="getProvidersByAcademicyearId"
      :get-visits="getVisits"
      :get-compensatory-request-general-info="getCompensatoryRequestGeneralInfo"
      :on-add-navigation="onAddNavigationHandler"
      :view-add-action="viewAddAction"
      :on-request-navigation="onRequestNavigation"
      :view-menu-request="true"
      :view-menu-documents-action="true"
      :view-menu-visits-action="true"
      :view-menu-visit-registration-action="false"
      :view-certification-action="false"
      :view-menu-edit-action="false"
      :view-menu-referral-action="true"
      :on-download="onDownload"
      :on-download-referral-sheet="downloadSheetRefferal"
      :get-documents-by-student-service="getDocumentsByStudentService"
      :view-determination-options="true"
      :on-determination-submit="onDeterminationSubmit"
      :get-determination-reasons="getDeterminationReasons"
      :is-intervention-are-approved="isInterventionAreAproved"
      :can-update-intervetion="canUpdateIntervetion"
      :on-intervention-submit="onInterventionSubmit"
      :save-referral-item-attachment="saveReferralItemAttachment"
      :can-approve-service="canAcceptCompensatoryService"
      :can-reject-service="canDenyCompensatoryService"
      :has-return-status-permission="hasReturnStatusPermission"
      :update-request-status-to-previous="updateRequestStatusToPrevious"
      @on-click-return="onClickReturnHandler"
      @on-click-comments="goToComments"
      :on-add-comment="onAddComment"
      main-page-name="Inicio / PEI"
      show-add-comment
    />
  </div>
</template>

<script>
import { CompensatoryRequestSearch } from 'compensatory-service';
import {
  compensatoryRequestSearchInitFilters as _compensatoryRequestSearchInitFilters,
  compensatoryRequestSearch as _compensatoryRequestSearch,
  getCompensatoryRequestInterventions as _getCompensatoryRequestInterventions,
  getProvidersByAcademicyearId as _getProvidersByAcademicyearId,
  getVisits as _getVisits,
  getReferralDocumentsByStudentService as _getDocumentsByStudentService,
  saveReferralItemAttachment as _saveReferralItemAttachment,
  getGeneralInfo as _getGeneralInfo,
  //Determination
  getDeterminationReasons as _getDeterminationReasons,
  submitDetermination as _submitDetermination,
  submitEducationalDetermination as _submitEducationalDetermination,
  isInterventionAreApproved as _isInterventionAreApproved,
  //Intervention
  submitIntervention as _submitIntervention,
  //Regresar Estatus
  updateRequestStatusToPrevious as _updateRequestStatusToPrevious,
} from '@/modules/compensatory-service/api.js';
import compensatoryRequestTypes from '@/utils/constants/compensatoryRequestTypes';
import compensatoryServiceStatus from '@/utils/constants/compensatoryServiceStatus';

import locationService from '@/modules/common/location.api';
import generalService from '@/services/pei/general';
import commentTypes from '@/utils/constants/comment/commentTypes';
import studentService from '@/services/student.js';
import objectToFormData from 'object-to-formdata';

export default {
  components: {
    CompensatoryRequestSearch,
  },
  data() {
    return {
      result: {
        data: [],
        pagination: {
          currentPage: 1,
          totalItemCount: 0,
          pageCount: 0,
          count: 0,
          perPage: 10,
        },
      },
    };
  },
  computed: {
    viewAddAction() {
      return false;
      // Temp disabled for published
      // return this.$store.getters.HasPermission(
      //   'provider.compensatoryService.add'
      // );
    },
    hasReturnStatusPermission() {
      return this.$store.getters.HasPermission(
        'provider.compensatory.service.returnstatus'
      );
    },
  },
  methods: {
    async compensatoryRequestSearchInitFilters() {
      return await _compensatoryRequestSearchInitFilters();
    },
    async compensatoryRequestSearch(model, newPage, currentPage) {
      return await _compensatoryRequestSearch(model, newPage, currentPage);
    },
    async getCompensatoryRequestInterventions(id) {
      return await _getCompensatoryRequestInterventions(id);
    },
    async getProvidersByAcademicyearId(academicYearId) {
      return await _getProvidersByAcademicyearId(academicYearId);
    },
    getRegions(filters) {
      return locationService.getRegions(filters);
    },
    getDistricts(filters) {
      return locationService.getDistricts(filters);
    },
    getMunicipalities(filters) {
      return locationService.getMunicipalities(filters);
    },
    getSchools(filters) {
      return locationService.getSchools(filters);
    },
    getVisits(admissionId, requestType) {
      return _getVisits(admissionId, requestType);
    },
    getCompensatoryRequestGeneralInfo(id, isEducational = false) {
      return _getGeneralInfo(id, isEducational);
    },
    onAddNavigationHandler(item) {
      this.$router.push({
        name: 'CompensatorySearchService',
        params: {
          ...item,
        },
      });
    },
    async onRequestNavigation(item) {
      const request = {
        requestId: item.id,
        admissionId: item.admissionId,
        studentServiceId: item.studentServiceId,
        isReposition: item.requestTypeId == 1,
        studentName: item.studentName,
        serviceSpecialistName: item.isEducational
          ? item.specialistName
          : item.generalInfo.specialistName,
        disciplineName: item.isEducational
          ? item.disciplineName
          : item.generalInfo.disciplineName,
        isEducational: item.isEducational,
      };
      this.$router.push({
        name: 'CompensatoryRequest',
        query: {
          isReposition:
            item.requestTypeId == compensatoryRequestTypes.Reposicion,
          isEducational: item.isEducational,
        },
        params: {
          ...request,
          ...this.$route.params,
          readOnly: item.statusId !== compensatoryServiceStatus.Nuevo,
        },
      });
    },
    onDownload(documentId) {
      return generalService.getDocument(documentId);
    },
    getDocumentsByStudentService(payload, currentPage, pageSize) {
      return _getDocumentsByStudentService(payload, currentPage, pageSize);
    },
    onDeterminationSubmit(item) {
      if (item.isEducational) {
        return _submitEducationalDetermination(item);
      }

      return _submitDetermination(item);
    },
    getDeterminationReasons() {
      return _getDeterminationReasons();
    },
    async isInterventionAreAproved(requestId) {
      return _isInterventionAreApproved(requestId);
    },
    canUpdateIntervetion() {
      let canUpdate = this.$store.getters.HasPermission(
        'compensatoryrequest.interventionsdebts.change'
      );
      return canUpdate;
    },
    canAcceptCompensatoryService() {
      let canApprove = this.$store.getters.HasPermission(
        'eduesp.compensatoryService.accept'
      );
      return canApprove;
    },
    canDenyCompensatoryService() {
      let canDeny = this.$store.getters.HasPermission(
        'eduesp.compensatoryService.deny'
      );
      return canDeny;
    },
    onInterventionSubmit(item) {
      return _submitIntervention(item);
    },
    updateRequestStatusToPrevious(payload) {
      return _updateRequestStatusToPrevious(payload);
    },
    async downloadSheetRefferal(studentServiceId) {
      return await this.$ApiGet(
        '/api/report/studentservice/referralreport/' + studentServiceId
      )
        .then((res) => {
          self.report = res.data;
          generalService.documentDownloadReport(
            self.report.content,
            self.report.filename
          );
        })
        .catch((err) => {
          self.response = err;
        });
    },
    async saveReferralItemAttachment(formData) {
      return await _saveReferralItemAttachment(formData);
    },
    onClickReturnHandler() {
      this.$router.go(-1);
    },
    goToComments(item) {
      this.$router.push({
        path: `/student/comments/commentshistory/${item.studentSie}/${commentTypes.SolicitudHorasCompensatorias}`,
      });
    },
    async onAddComment(payload) {
      let formData = objectToFormData(
        {
          studentSieId: payload.studentSie,
          categoryTypeId: commentTypes.SolicitudHorasCompensatorias,
          description: payload.comment,
        },
        { indices: true }
      );

      if (payload.file) {
        formData.append('attachment', payload.file);
      }

      return await studentService.saveComment(formData);
    },
  },
  async mounted() {},
};
</script>

<style scoped>
.overflow-hidden {
  overflow: visible !important;
}
</style>
